<!--
 * @Description: 常规工作 班主任代选 批量设置
 * @Author: PF
 * @Date: 2023-06-13 16:55:12
 * @LastEditors: PF
 * @LastEditTime: 2023-06-16 13:57:52
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openPiLiangSheZhi" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">批量设置</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openPiLiangSheZhi', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" style="display: block;">
        <el-row>
          <el-col class="mb10" :span="24">
            <el-card shadow="never">
              <template #header>
                <div class="card-header">
                  <span>限定选修课</span>
                </div>
              </template>
              <div v-for="(item, index) in xdxxkData" :key="index">
                <div class="mb10" v-for="(val, v) in item.xdxxkfzs" :key="v">
                  <span>第{{ v+1 }}组</span>
                  <span class="ml10">(限选</span>
                  <span v-if="val.zsxksl === val.zdxksl">{{ val.zdxksl }}</span>
                  <span v-else>{{ val.zsxksl }}-{{ val.zdxksl }}</span>
                  <span>门课程)</span>
                  <el-checkbox-group v-model="xdxxks[v].ids">
                    <el-checkbox v-for="(kcitem, kcind) in val.xdxxkfzkcs" :key="kcind" :label="kcitem.id">{{ kcitem.kcmc }}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col class="mb10" :span="24">
            <el-card shadow="never">
              <template #header>
                <div class="card-header">
                  <span>任意选修课</span>
                  <span class="ml10">(限选</span>
                  <span v-if="ryxxkData.zsxksl === ryxxkData.zdxksl">{{ ryxxkData.zdxksl }}</span>
                  <span v-else>{{ ryxxkData.zsxksl }}-{{ ryxxkData.zdxksl }}</span>
                  <span>门课程)</span>
                </div>
              </template>
              <el-checkbox-group v-model="ryxxks">
                <el-checkbox v-for="(item, index) in ryxxkData.list" :key="index" :label="item.id" >{{ item.kcmc }}</el-checkbox>
              </el-checkbox-group>
            </el-card>
          </el-col>
        </el-row>
        <el-form-item label="选择学生">
          <!-- 多选 BEGIN -->
          <div class="an-niu wp100">
            <el-button type="primary" class="w180" @click="openDuoTiao=true;row={bjid:row.bjid,ids:ruleForm.xsids}">选择</el-button>
            <el-button link v-if="xsData.length" @click="xsData=[];ruleForm.xsids=[]">清空</el-button>
          </div>
          <div class="biao-qian" v-if="xsData.length">
            <el-tag class="mr10 mt10" v-for="(item, index) in xsData" :key="index" closable :disable-transitions="false" @close="YiChu(index)">
              {{ item.xm }}
            </el-tag>
          </div>
        </el-form-item>
        <!-- 多选 END -->
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openPiLiangSheZhi', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <xueshengduotiao v-if="openDuoTiao" v-model:openDuoTiao="openDuoTiao" :row="row" @ReturnData="duoTiaoReturnData" />
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import {
  submitForm,
  actionPost,
  closeWindow,
  loadSelect
} from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import xueshengduotiao from './xueshengduotiao'
const props = defineProps({ openPiLiangSheZhi: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openPiLiangSheZhi', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({ xsids: [], xdxxks: [], ryxxks: [] })
const row = ref()

const ryxxks = ref([])
const xdxxks = ref([])
const xsData = ref([])
const openDuoTiao = ref(false)
const duoTiaoReturnData = (data) => {
  xsData.value = data || []
  ruleForm.value.xsids = data.map((item) => item.id)
}
const YiChu = (index) => {
  xsData.value.splice(index, 1)
  ruleForm.value.xsids.splice(index, 1)
}

const xdxxkData = ref([])
const ryxxkData = ref([])
watch(
  () => props.openPiLiangSheZhi,
  () => {
    if (props.openPiLiangSheZhi) {
      row.value = props.row
      ruleForm.value.xqid = props.row.xqid
      loadSelect({
        url: '/api/v2/jiaowu/jiaowuxuanxiukexiandingxuanxiukefangan/banjilist',
        data: xdxxkData,
        parms: { xqid: props.row.xqid, bjid: props.row.bjid },
        order: 'kch',
        sort: 'asc',
        loadSuccess: function (res) {
          res.data.forEach(element => {
            element.xdxxkfzs.forEach((item, i) => {
              const obj = { fz: (i + 1), zdxksl: item.zdxksl, zsxksl: item.zsxksl, xdxxkfzid: item.id, ids: [] }
              xdxxks.value.push(obj)
            })
          })
        }
      })
      loadSelect({ url: '/api/v2/jiaowu/jiaowuxuanxiukerenyixuanxiuke/banjilist', data: ryxxkData, parms: { xqid: props.row.xqid, bjid: props.row.bjid }, order: 'kch', sort: 'asc' })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  ruleForm.value.xdxxks = []
  ruleForm.value.ryxxks = []
  // 
  try {
    xdxxks.value.forEach((element) => {
      if (element.ids.length >= element.zsxksl && element.ids.length <= element.zdxksl) {
        if (element.ids.length !== 0) {
          element.ids.forEach(item => {
            const obj = { xdxxkfzid: element.xdxxkfzid, xdxxkfzkcid: item }
            ruleForm.value.xdxxks.push(obj)
          })
        }
      } else { throw element }
    })
  } catch (e) {
    
    return warningPrompt('限定选修课 第' + e.fz + '组 (限选' + e.zsxksl + '-' + e.zdxksl + '门课程)')
  }
  ruleForm.value.ryxxks = ryxxks.value.map(item => ({ ryxxkid: item })) || []
  if (ruleForm.value.ryxxks.length < ryxxkData.value.zsxksl || ruleForm.value.ryxxks.length > ryxxkData.value.zdxksl) {
    return warningPrompt('任意选修课(限选' + ryxxkData.value.zsxksl + '-' + ryxxkData.value.zdxksl + '门课程)')
  }
  if (ruleForm.value.xsids.length === 0) {
    return warningPrompt('学生不能为空')
  }
  // 
  // return
  submitForm({
    url: '/api/v2/jiaowu/jiaowuxuanxiukexueshengxuanxiuke/insert',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openPiLiangSheZhi', emits, true)
    }
  })
}
</script>
